import { render, staticRenderFns } from "./SSOAccountOptionsTitle.vue?vue&type=template&id=103c1dbe"
import script from "./SSOAccountOptionsTitle.vue?vue&type=script&lang=ts"
export * from "./SSOAccountOptionsTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports